import { createContext, useContext } from 'react';

export const ShowroomTransitionContext = createContext({ exitExperience: () => {} });

export const useShowroomTransition = () => useContext(ShowroomTransitionContext);
